export const FETCH_PSYCH_REPORT_REQUEST = "FETCH_PSYCH_REPORT_REQUEST";
export const FETCH_PSYCH_REPORT_SUCCESS = "FETCH_PSYCH_REPORT_SUCCESS";
export const FETCH_PSYCH_REPORT_FAILURE = "FETCH_PSYCH_REPORT_FAILURE";
